import { render, staticRenderFns } from "./copyProject.vue?vue&type=template&id=26bb298d&scoped=true"
import script from "./copyProject.vue?vue&type=script&lang=js"
export * from "./copyProject.vue?vue&type=script&lang=js"
import style0 from "./copyProject.vue?vue&type=style&index=0&id=26bb298d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bb298d",
  null
  
)

export default component.exports